export const state = () => ({
  catalog: {},
  loading: false,
  loaded: false,
  error: null,
});
